export const generateVideoThumbnail = (
  file: File | string,
  signal: AbortSignal
) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const video = document.createElement('video');

    video.autoplay = true;
    video.muted = true;
    video.crossOrigin = 'anonymous';
    video.preload = 'none';

    video.src = typeof file === 'string' ? file : URL.createObjectURL(file);
    video.onloadeddata = () => {
      video.currentTime = 1;
      const ctx = canvas.getContext('2d');

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      ctx?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      video.pause();
      return resolve(canvas.toDataURL('image/png'));
    };
    if (signal) {
      signal.onabort = () => {
        video.src = '';
        video.load();
      };
    }
  });
};
